import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin-right":"15px"} }
const _hoisted_2 = { style: {"margin-right":"15px"} }

import {
  ref,
  withDefaults,
  computed,
  watch,
  defineModel
} from 'vue';
import {
  BaseTable,
  XrkTable,
  XrkTableProps,
  useTableColumn,
  BaseButton
} from 'xrk-components';
import { formatter } from '@/utils';
import { PAY_PASSAGEWAY_MAPPING } from '@/common/constants/bank';
import { notInvoicedList } from '@V/invoice/src/data-source/apis';
import { ORDER_TYPE, PAY_TYPE } from '@constants/order';
import { taxPatternMapping } from '@constants/project';
import {
  MakeOutAnInvoiceParams,
  NotInvoicedListParams
} from '@V/invoice/src/data-source/types';
import { useJumpToFinishedOrderList, useJumpToOrderDetail } from '@hooks/order';

type FormData = MakeOutAnInvoiceParams & NotInvoicedListParams;


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-detail-individual-dialog-list',
  props: /*#__PURE__*/_mergeModels({
    disabled: { type: Boolean },
    contentRef: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose }) {

const props = __props;

const xrkTableRef = ref();
const formData = _useModel<FormData>(__props, "modelValue");
const totalPrice = ref(0);

const selections = computed(() => {
  return xrkTableRef.value?.getSelectionRows?.() || [];
});
const selectionUserDefinedPrice = computed(() => {
  return selections.value.reduce((pre, cur) => {
    return pre + cur.userDefinedPrice;
  }, 0);
});

watch(
  () => selections.value,
  async v => {
    if (v.length) {
      const ids = v.map(item => item.openOrderId);
      formData.value.openOrderIds = ids;
    } else {
      formData.value.openOrderIds = [];
    }
    formData.value.invoiceAmount = selectionUserDefinedPrice.value || 0;
  }
);

__expose({
  getInvoiceAmount: () => selectionUserDefinedPrice.value
});

const getListAjax = async params => {
  const resp = await notInvoicedList({ ...params, ...formData.value });
  totalPrice.value = resp.data.totalPrice;
  return resp;
};

const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchColumns: [],
  searchBtn: {
    show: true,
    text: '搜索',
    async beforeSearch() {
      await props.contentRef.validate();
    }
  },
  resetBtn: {
    show: false,
    text: '重置'
  }
});

const tableConfig = computed(() => {
  return {
    tableColumns: [
      useTableColumn({
        type: '_selection',
        prop: 'openOrderId',
        align: 'center',
        fixed: 'left',
        width: 110
      }),
      // useTableColumn({
      //   type: 'index',
      //   label: '序号',
      //   width: '80px'
      // }),
      useTableColumn({
        label: '购买方',
        prop: 'purchaserName',
        width: '180px'
      }),
      useTableColumn({
        label: '项目名称',
        prop: 'projectName',
        width: '180px'
      }),
      useTableColumn({
        label: '交易结构',
        prop: 'taxPattern',
        formatter: ({ cellValue }) =>
          formatter.defaultFormat(
            cellValue,
            () => taxPatternMapping[cellValue].label
          )
      }),
      useTableColumn({
        label: '订单编号',
        prop: 'userDefinedOrderNo',
        width: '260px',
        render({ row }) {
          return (
            <BaseButton
              link
              onClick={() => {
                useJumpToFinishedOrderList(row.userDefinedOrderNo, {
                  pageName: 'finished',
                  method: 'open'
                });
              }}
            >
              {row.userDefinedOrderNo}
            </BaseButton>
          );
        }
      }),
      useTableColumn({
        label: '订单类型',
        prop: 'userDefinedOrderType',
        formatter: ({ cellValue }) =>
          formatter.defaultFormat(cellValue, () => ORDER_TYPE[cellValue].label)
      }),
      useTableColumn({
        label: '销售方',
        prop: 'theSellerName',
        width: '180px'
      }),
      useTableColumn({
        label: '收款时间',
        prop: 'receiveAt',
        width: '180px',
        formatter: ({ cellValue }) => formatter.date(cellValue)
      }),
      useTableColumn({
        label: '支付通道',
        prop: 'payPassagewayCode',
        formatter: ({ cellValue }) =>
          formatter.defaultFormat(
            cellValue,
            () => PAY_PASSAGEWAY_MAPPING[cellValue].label
          )
      }),
      useTableColumn({
        label: '付款方式',
        prop: 'payType',
        formatter: ({ cellValue }) =>
          formatter.defaultFormat(cellValue, () => PAY_TYPE[cellValue].label)
      }),
      useTableColumn({
        label: '金额',
        prop: 'userDefinedPrice',
        width: '180px',
        render({ row }) {
          return (
            <BaseButton
              link
              onClick={() => {
                useJumpToOrderDetail(row.userDefinedOrderNo, {
                  method: 'open'
                });
              }}
            >
              {formatter.fen2yuan(row.userDefinedPrice)}
            </BaseButton>
          );
        }
      })
    ].filter(item => item)
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_unref(XrkTable), {
      ref_key: "xrkTableRef",
      ref: xrkTableRef,
      requestNow: false,
      getListAjax: getListAjax,
      searchConfig: searchConfig.value,
      tableConfig: tableConfig.value
    }, {
      tableBefore: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_1, " 价税合计：" + _toDisplayString(_unref(formatter).fen2yuan(selectionUserDefinedPrice.value)) + "元 ", 1),
          _createElementVNode("span", null, "最大开票金额：" + _toDisplayString(_unref(formatter).fen2yuan(totalPrice.value)) + "元", 1)
        ])
      ]),
      _: 1
    }, 8, ["searchConfig", "tableConfig"]), [
      [_vShow, !props.disabled]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_2, " 价税合计：" + _toDisplayString(_unref(formatter).fen2yuan(selectionUserDefinedPrice.value)) + "元 ", 1),
        _createElementVNode("span", null, "最大开票金额：" + _toDisplayString(_unref(formatter).fen2yuan(totalPrice.value)) + "元", 1)
      ]),
      _createVNode(_unref(BaseTable), {
        data: selections.value,
        columns: tableConfig.value.tableColumns
      }, null, 8, ["data", "columns"])
    ], 512), [
      [_vShow, props.disabled]
    ])
  ], 64))
}
}

})